import React, { useState, useEffect, useCallback } from "react";
import infoIcon from "../../../../../../assets/images/Icons/info_icon.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../../helpers/global_helper";
import BetSuccessPopup from "../../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../../Popups/ErrorInnerPopup";
import {
  formatPrice,
  formatPricewithdecimal,
} from "../../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import CancelledBetDeskonPopup from "../../../../../Popups/CancelledBetDeskonPopup";
import ConfirmBetDeskonPopup from "../../../../../Popups/ConfirmBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../../../redux/actions";
import GameClosedPopup from "../../../GameClosedPopup";
import MarketClose from "../../../MarketClose";

const PolaTarungBetFullVersiWap = (props) => {
  const dispatch = useDispatch();
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const [respData, setRespData] = useState([]);
  const [rowsToShow, setRowsToShow] = useState(1);
  const [showTooltip, setShowTooltip] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");
  const [totalBaris, setTotalBaris] = useState("");
  const [totalDiskon, setTotalDiskon] = useState("");
  const [totalPembelian, setTotalPembelian] = useState("");
  const [totalPembayaran, setTotalPembayaran] = useState("");
  const [inputValues, setInputValues] = useState([]);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const [rows, setRows] = useState([
    {
      "4D": "",
      "3D Depan": "",
      "3D Belakang": "",
      "2D Depan": "",
      "2D Tengah": "",
      "2D Belakang": "",
    },
  ]);
  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "polatarung",
    betTogelAuth: "betTogelAuth",
    dataangka: [],
    databet: [],
    fastbet: true,
    action: "save",
    isfullbet: 1,
    allowPartner: "allowPartner",
  });
  const [submitReqData, setSubmitReqData] = useState({
    gameId: gameId,
    gameType: "polatarung",
    betTogelAuth: "betTogelAuth",
    dataangka: [],
    fastbet: true,
    action: "save",
    isfullbet: 1,
    allowPartner: "allowPartner",
    fastbet: true,
    dfp: "fullbet",
    databet: [],
  });

  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');
  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = betDiscount.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = betDiscount.showMultipleFullbet;
    } else {
      multiple = betDiscount.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type]);

  const handleRowsToShowChange = (e) => {
    setRowsToShow(parseInt(e.target.value, 10));
  };
  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };
  // const validateInput = (value) => {
  //   const regex = /^[0-9,]*$/;
  //   if (!regex.test(value)) {
  //     setErrorMessage("Please enter numbers separated by commas only.");
  //     setShowErrorPopup(true);
  //     return false;
  //   }
  //   const numbers = value.split(',').map(num => num.trim());
  //   for (let num of numbers) {
  //     if (num !== '' && !/^\d+$/.test(num)) {
  //       setErrorMessage("Only numeric values are allowed.");
  //       setShowErrorPopup(true);
  //       return false;
  //     }
  //   }
  //   const filteredNumbers = numbers.filter(num => num !== '');
  //   const uniqueNumbers = new Set(filteredNumbers);
  //   if (uniqueNumbers.size !== filteredNumbers.length) {
  //     setErrorMessage("Duplicate numbers are not allowed.");
  //     setShowErrorPopup(true);
  //     return false;
  //   }
  //   return true;
  // };

  const validateInput = (value) => {
    const regex = /^[0-9,]*$/;
    if (value === "") return true;
    if (!regex.test(value)) {
      setErrorMessage(props.t("bet_format_wrong"));
      setShowErrorPopup(true);
      return false;
    }
    return true;
  };

  const finalValidateInput = (value) => {
    const numbers = value.split(",").map((num) => num.trim());
    if (numbers.length !== 4) {
      setErrorMessage(props.t("bet_format_wrong"));
      setShowErrorPopup(true);
      const newRows = rows.map(() => ({
        "Angka Tarung": "",
        "4D": "",
      }));
      setRows(newRows);
      return false;
    }
    for (let num of numbers) {
      if (num !== "" && !/^\d+$/.test(num)) {
        setErrorMessage(props.t("bet_format_wrong"));
        setShowErrorPopup(true);
        const newRows = rows.map(() => ({
          "Angka Tarung": "",
          "4D": "",
        }));
        setRows(newRows);
        return false;
      }
      const digits = new Set();
      for (let digit of num) {
        if (digits.has(digit)) {
          setErrorMessage(props.t("betting_number_repeat"));
          setShowErrorPopup(true);
          const newRows = rows.map(() => ({
            "Angka Tarung": "",
            "4D": "",
          }));
          setRows(newRows);
          return false;
        }
        digits.add(digit);
      }
    }
    const filteredNumbers = numbers.filter((num) => num !== "");
    const uniqueNumbers = new Set(filteredNumbers);
    // if (uniqueNumbers.size !== filteredNumbers.length) {
    //   setErrorMessage(props.t("betting_number_repeat"));
    //   setShowErrorPopup(true);
    //   const newRows = rows.map(() => ({
    //     "Angka Tarung": "",
    //     "4D": "",
    //   }));
    //   setRows(newRows);
    //   return false;
    // }
    return true;
  };

  const handleBlur = (e, index, columnName) => {
    const value = e.target.value;
    if (columnName === "Angka Tarung") {
      finalValidateInput(value);
    }
  };

  const validate4DInput = (value) => {
    if (value === "") return true;

    if (!/^\d+$/.test(value)) {
      setErrorMessage(props.t("bet_format_wrong"));
      setShowErrorPopup(true);
      return false;
    }
    // if (value != "" && value < betDiscount.showMin4dFullbet / 1000) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    if (value != "" && value > betDiscount.showMax4dFullbet / 1000) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
      return false;
    }
    return true;
  };

  const handleInputChange = (e, rowIndex, columnName) => {
    const value = e.target.value;
    if (columnName === "Angka Tarung" && !validateInput(value)) {
      return;
    }
    if (columnName === "4D" && !validate4DInput(value)) {
      return;
    }
    const newRows = [...rows];
    newRows[rowIndex][columnName] = value;
    setRows(newRows);

    if (columnName === "Angka Tarung") {
      const numbers = value.split(",").map((num) => num.trim());
      if (numbers.length === 4) {
        setReqData((prev) => ({
          ...prev,
          databet: [
            `as-${numbers[0]}`,
            `kop-${numbers[1]}`,
            `kepala-${numbers[2]}`,
            `ekor-${numbers[3]}`,
          ],
        }));
      }
    }
  };

  const validateAngkaTarung = () => {
    for (let row of rows) {
      if (!row.hasOwnProperty("Angka Tarung") || !row["Angka Tarung"].trim()) {
        setErrorMessage(props.t("bet_format_wrong"));
        setShowErrorPopup(true);
        return false;
      }

      if (!row.hasOwnProperty("4D") || !row["4D"].trim()) {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
        return false;
      }
    }
    return true;
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcess = () => {
    if (!validateAngkaTarung()) {
      return;
    }

    const newDataAngka = rows
      .map((rowData) => {
        const transformedRow = [];
        const columns = [
          "4D",
          "3D Depan",
          "3D Belakang",
          "2D Depan",
          "2D Tengah",
          "2D Belakang",
        ];
        columns.forEach((column) => {
          const key = column.toLowerCase().replace(/\s+/g, "-");
          if (column === "4D" && rowData[column]) {
            transformedRow.push([key, rowData[column] * multipleValue, "success"]);
          } else {
            transformedRow.push([key, null, "null"]);
          }
        });
        return transformedRow;
      })
      .flat();

    setReqData((prev) => ({
      ...prev,
      dataangka: newDataAngka,
    }));
  };

  useEffect(() => {
    if (reqData.dataangka.length > 0) {
      makeAjax(url.TOGEL_API.processPolaTarung, reqData).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowConfirmationPopup(false);
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            return;
          }
          if (response.code === "market_close_err") {
            setShowConfirmationPopup(false);
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            return;
          }
          if (response.code !== "validation_error") {
            setErrorMessage(props.t(response.code));
            setShowErrorPopup(true);
            return;
          }
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        const dummy = response.data["4d"];
        setTextareaValue(dummy);
      });
    }
  }, [reqData.dataangka]);

  const calculateTotal = () => {
    if (textareaValue == "") {
      showMessage(props.t("format_input"), "error", "error");
      return;
    }
    const totalData = {
      fastbet: true,
      isfullbet: 1,
      databet_4d: textareaValue,
      gameId: gameId,
      gameType: "polatarung",
    };

    let matchValidate = matchValidateVersi("polatarung", totalData);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, totalData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowConfirmationPopup(false);
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code === "market_close_err") {
          setShowConfirmationPopup(false);
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
        return;
      }

      setTotalBaris(response.data["line"]);
      setTotalDiskon(response.data["disc"]);
      setTotalPembelian(response.data["tover"]);
      setTotalPembayaran(response.data["pay"]);
    });
  };

  const handleSubmit = () => {
    if (textareaValue == "") {
      showMessage(props.t("format_input"), "error", "error");
      return;
    }
    const totalData = {
      fastbet: true,
      isfullbet: 1,
      databet_4d: textareaValue,
      gameId: gameId,
      gameType: "polatarung",
    };

    let matchValidate = matchValidateVersi("polatarung", totalData);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, totalData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowConfirmationPopup(false);
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code === "market_close_err") {
          setShowConfirmationPopup(false);
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
        return;
      }

      setTotalBaris(response.data["line"]);
      setTotalDiskon(response.data["disc"]);
      setTotalPembelian(response.data["tover"]);
      setTotalPembayaran(response.data["pay"]);
    });
    setShowConfirmationPopup(true);
    const newDataAngka = textareaValue.split("+").flatMap((item) => {
      const parts = item.split("#");
      const angka = parts[0].split("*");
      const nilai = parseInt(parts[1]) * multipleValue; // Multiply by 1000
      return angka.map((num) => [
        num.padStart(4, "X"),
        nilai,
        "success"
      ]);
    });

    setSubmitReqData((prev) => ({
      ...prev,
      dataangka: newDataAngka,
    }));
    // calculateTotal();
  };

  useEffect(() => {
    resetAllFields();
  }, [gameId]);

  // useEffect(() => {
  //   if (submitReqData.dataangka.length > 0) {
  //     makeAjax(url.TOGEL_API.process4D3D2D, submitReqData).then(response => {
  //       if (response.status !== respStatus['SUCCESS']) {
  //         if (response.code !== "validation_error") {
  //           if (response.code == "market_close_err") {
  //             showMessage("This Region Togel market is currently closed", "error", "error")
  //             return;
  //           }
  //           setErrorMessage('No bets are placed. Please fill in your bet and bet amount.')
  //           setShowErrorPopup(true)
  //           return;
  //         }
  //         showMessage("The guess or bet is wrong. Please fill in correctly!", "error", "error");
  //         return;
  //       }
  //       setSubmitRespData(prevData => [...prevData, response.data]);
  //       setSuccessPopup(true);

  //       const dummy = response.data['4d']
  //       setTextareaValue(dummy);
  //       setTotalBaris(response.data['line']);
  //       setTotalDiskon(response.data['disc']);
  //       setTotalPembelian(response.data['tover']);
  //       setTotalPembayaran(response.data['pay']);
  //     });
  //   }
  // }, [submitReqData.dataangka])
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.process4D3D2D, submitReqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowConfirmationPopup(false);
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code === "market_close_err") {
          setShowConfirmationPopup(false);
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
        return;
      }
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);

      const dummy = response.data["4d"];
      setTextareaValue(dummy);
      setTotalBaris(response.data["line"]);
      setTotalDiskon(response.data["disc"]);
      setTotalPembelian(response.data["tover"]);
      setTotalPembayaran(response.data["pay"]);
    });
  };
  const resetAllFields = () => {
    setSuccessPopup(false);
    setTextareaValue("");
    setTotalBaris("");
    setTotalDiskon("");
    setTotalPembelian("");
    setTotalPembayaran("");
    const newRows = rows.map(() => ({
      "Angka Tarung": "",
      "4D": "",
    }));
    setRows(newRows);
    setReqData({
      gameId: gameId,
      gameType: "polatarung",
      betTogelAuth: "betTogelAuth",
      dataangka: [],
      databet: [],
      fastbet: true,
      action: "save",
      isfullbet: 1,
      allowPartner: "allowPartner",
    });
    setSubmitReqData({
      gameId: gameId,
      gameType: "polatarung",
      betTogelAuth: "betTogelAuth",
      dataangka: [],
      fastbet: true,
      action: "save",
      isfullbet: 1,
      allowPartner: "allowPartner",
      fastbet: true,
      dfp: "fullbet",
      databet: [],
    });
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };
  return (
    <>
      <div className="polaTarung_versiwap_wrapper">
        {showGameClose ? (
          <GameClosedPopup />
        ) : showMarketClose ? (
          <MarketClose />
        ) : (
          <>
            <div className="polatarung_versiwap_container">
              <div className="container">
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>Angka Tarung</th>
                      <th>4D</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow)].map((_, index) => (
                      <tr key={index}>
                        <td className="inputs">
                          <input
                            type="text"
                            value={rows[index]["Angka Tarung"]}
                            onChange={(e) =>
                              handleInputChange(e, index, "Angka Tarung")
                            }
                            onBlur={(e) => handleBlur(e, index, "Angka Tarung")}
                            placeholder="Format Penulisan : 1234,4567,6789,5678"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            type="text"
                            value={rows[index]["4D"]}
                            onChange={(e) => handleInputChange(e, index, "4D")}
                            placeholder="Bet"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="btnGenerate">
                <button onClick={submitProcess}>Generate</button>
              </div>
            </div>
            <div className="versicontainer_new">
              <p>4D</p>
              <textarea
                rows="7"
                placeholder="123*1234*12#5+11*222*333#1+33*777#2"
                value={textareaValue}
                onChange={(e) => setTextareaValue(e.target.value)}
              ></textarea>
            </div>

            {/* 1 */}
            <div className="versiweb_resultwrapper">
              <div className="versiweb_result_left">
                <div className="result_left">
                  <p>
                    <span>Total {props.t("line")}</span> :{" "}
                    {totalBaris ? totalBaris : "-"}
                  </p>
                  <p>
                    <span>Total {props.t("purchases")}</span> :{" "}
                    {totalPembelian ? formatPrice(totalPembelian) : "-"}&nbsp;
                  </p>
                </div>
                <div className="result_right">
                  <p>
                    <span>Total {props.t("discount")}</span>:{" "}
                    {totalDiskon ? formatPrice(totalDiskon) : "-"}
                  </p>
                  <p>
                    <span>Total {props.t("payment")}</span> :{" "}
                    {totalPembayaran ? formatPrice(totalPembayaran) : "-"}
                  </p>
                </div>
                <div className="info_icon">
                  <img
                    src={infoIcon}
                    alt=""
                    // onMouseOver={toggleTooltip}
                    // onMouseOut={toggleTooltip}
                    onClick={toggleTooltip}
                  />
                  {showTooltip && (
                    <div
                      className="info_icon_overlay"
                      onClick={() => setShowTooltip(false)}
                    ></div>
                  )}
                  {showTooltip && (
                    <span className="tooltip">
                      <div className="tooltip_wrapper">
                        <span className="tooltip_heading">
                          Contoh Format Taruhan
                        </span>
                        <span className="tooltip_content">
                          {" "}
                          1234, 4567, 6789, 5678
                        </span>
                      </div>
                    </span>
                  )}
                </div>
              </div>
              <div className="versiweb_result_right">
                <p>
                  Konversi<br></br> 1 = {multipleValue}
                </p>
              </div>
            </div>
            {/* button*/}
            <div className="versiweb_resultwrapper">
              <div className="versiweb_result_left">
                <div className="button_left">
                  <button onClick={calculateTotal}>
                    {props.t("count_total")}
                  </button>
                </div>
                <div className="button_right">
                  <button onClick={resetAllFields}>{props.t('reset')}</button>
                </div>
              </div>
              <div className="versiweb_result_right btn_Submit">
                <button onClick={handleSubmit}>{props.t('submit')}</button>
              </div>
            </div>
          </>
        )}

        {showConfirmationPopup && (
          <ConfirmBetDeskonPopup
            onClose={hanldeConfirmationPopupClose}
            submitProcessOk={submitProcessOk}
          />
        )}
        {showCancelledPopup && (
          <CancelledBetDeskonPopup
            onClose={() => setShowCanclledPopup(false)}
          />
        )}
        {successPopup && (
          <div className="popup-overlay ">
            <BetSuccessPopup
              response={SubmitRespData}
              onClose={resetAllFields}
            />
          </div>
        )}
        {
          /*---error popup --*/
          showErrorPopup && (
            <ErrorInnerPopup
              modalTitle={""}
              modalHeader={true}
              onCloseModal={() => setShowErrorPopup(false)}
            >
              <ErrorPopup
                message={errMessage}
                onClose={() => setShowErrorPopup(false)}
              />
            </ErrorInnerPopup>
          )
        }
      </div>
    </>
  );
};

export default withTranslation()(PolaTarungBetFullVersiWap);
